import { get, noop, set } from "lodash";

export const extendSliceWithExcelTable = ({
  rootPath,
  actionNames = {},
  onStateUpdated = noop,
} = {}) => {
  const {
    addCategoryByIndex = "addCategoryByIndex",
    updateAllItems = "updateAllItems",
    updateItemByPath = "updateItemByPath",
    removeItemByPath = "removeItemByPath",
    addChildByPath = "addChildByPath",
  } = actionNames;
  return {
    [updateAllItems]: (state, { payload = [] }) => {
      const updatedState = set(state, rootPath, payload);
      onStateUpdated(updatedState);
    },
    [updateItemByPath]: (state, { payload }) => {
      const { pathToValue, value } = payload;
      const originalData = get(state, rootPath, []);

      const updatedData = set(originalData, pathToValue, value);
      const updatedState = set(state, rootPath, updatedData);
      onStateUpdated(updatedState);
    },
    [removeItemByPath]: (state, { payload: path }) => {
      const categories = get(state, rootPath, []);
      let updatedState;

      if (path.length === 1) {
        categories.splice(path[0], 1);
        updatedState = set(state, rootPath, categories);
        onStateUpdated(updatedState);
        return;
      }

      const parentPath = path.slice(0, -1);
      const indexToRemove = path[path.length - 1];

      const parentArray = get(categories, parentPath);
      parentArray.splice(indexToRemove, 1);

      const updatedCategories = set(categories, parentPath, parentArray);
      updatedState = set(state, rootPath, updatedCategories);
      onStateUpdated(updatedState);
    },
    [addCategoryByIndex]: (state, { payload }) => {
      const categories = get(state, rootPath, []);
      const { category, index } = payload;

      categories.splice(index, 0, category);
      const updatedState = set(state, rootPath, categories);
      onStateUpdated(updatedState);
    },
    [addChildByPath]: (state, { payload }) => {
      const { pathToChild, child, index } = payload;
      const categories = get(state, rootPath, []);

      // Get the category's Children, and insert at {index + 1}
      const categoryItems = get(categories, pathToChild);
      categoryItems.splice(index, 0, child);

      const updatedCategories = set(categories, pathToChild, categoryItems);
      const updatedState = set(state, rootPath, updatedCategories);
      onStateUpdated(updatedState);
    },
  };
};
